<template>
    <div class="myTable">
        <div class="searchNav" >
<!--            <span><span class="searchNameStyle">ICCID ：</span><el-input v-model="searchInfo.iccid" clearable placeholder="请输入"></el-input></span>-->
            <span><span class="searchNameStyle">设备号 ：</span><el-input v-model="searchInfo.imei" clearable placeholder="请输入"></el-input></span>
            <span><span class="searchNameStyle">上报时间 ：</span>
                <el-date-picker
                        v-model="searchDateArr"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </span>
            <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
        </div>
        <div class="tableStyle">
            <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px" >
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column prop="imei" label="设备号"width="130"></el-table-column>
                <el-table-column prop="type" label="设备类型"></el-table-column>
                <el-table-column prop="probeCount" label="探头数量"></el-table-column>
<!--                <el-table-column prop="threshold" label="阈值"></el-table-column>-->
                <el-table-column prop="inUseNum" label="在用探头"></el-table-column>
                <el-table-column prop="configuredReportTime" label="设置定时"></el-table-column>
                <el-table-column prop="power" label="电量"></el-table-column>
                <el-table-column prop="deviceStatus" label="设备状态"></el-table-column>
<!--                <el-table-column prop="updateTime" label="更新时间" width="90"></el-table-column>-->
                <el-table-column prop="dataTraffic" label="流量"></el-table-column>
                <el-table-column prop="defaultReportTime" label="默认时间"></el-table-column>
                <el-table-column prop="location" label="归宿地"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="90"></el-table-column>
                <el-table-column prop="productModel" label="主板型号"></el-table-column>
                <!--        <el-table-column prop="serialPortNum" label="探头数量"></el-table-column>-->
                <!--        <el-table-column prop="unUsedNum" label="未用探头"></el-table-column>-->
                <el-table-column prop="softVersion" label="固件版本"></el-table-column>
                <el-table-column prop="bts" label="bts" width="120"></el-table-column>
                <el-table-column prop="iccid" label="ICCID" width="100"></el-table-column>
                <!-- 自定义空数据展示 -->
                <template slot="empty">
                    <div class="empty-container">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </template>
            </el-table>
            <el-pagination style="text-align: right;"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="currentPage"
                           :page-size="searchInfo.pageSize"
                           :page-sizes="[10,20, 50, 100]"
                           layout="sizes, prev, pager, next ,total"
                           :total="total">
            </el-pagination>
        </div>
        <div>
            <el-dialog
                    title="设备详情"
                    :visible.sync="infoDialogVisible"
                    width="50%"
                    :before-close="handleClose"
                    center>
                <div class="addInfoStyle">
                    <div><span>标题：</span>{{addInfo.title}}</div>
                    <div><span>反馈内容：</span>
                        <div v-html="addInfo.content"></div>
                    </div>
                </div>

            </el-dialog>
        </div>
    </div>

</template>

<script>
    import {axios} from "../../config/axios";
    import RichTextEditor from '../util/RichTextEditor';

    export default {
        name: "dev-stat-history",
        components: {
            RichTextEditor
        },
        data () {
            return {
                dialogTitle:'新增设备',
                total:1,
                tableData: [],
                loading: false,
                formLoading: false,
                dialogVisible: false,
                infoDialogVisible: false,
                currentPage:1,
                roleList:'',
                searchDateArr:[],
                addInfo:{
                    iccid:'',
                    productModel:'',
                    devParameter:'',
                    imei:'',
                    softVersion:'',
                },
                searchInfo:{
                    iccid:'',
                    imei:'',
                    searchDate:'',
                    pageNumber:1,
                    pageSize:50,
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            }
        },
        watch: {
            'searchInfo.iccid'(newVal,oldVal){
                if ("" == newVal){
                    this.pageInfo();
                }
            },
            'searchInfo.imei'(newVal,oldVal){
                if ("" == newVal){
                    this.pageInfo();
                }
            },
            'searchDateArr'(newVal,oldVal){
                if (null == newVal){
                    this.searchInfo.searchDate ="";
                    this.pageInfo();
                }
            },
        },
        created: function () {
            this.pageInfo();
        },
        methods:{
            search(){
                this.pageInfo();
            },
//改为全局方法
            // 获取编辑器中的内容
            handleContentChange(newContent) {
                this.addInfo.content = newContent;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchInfo.pageNumber = val ;
                this.pageInfo();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.currentPage = 0;
                this.searchInfo.pageSize = val ;
                this.pageInfo();
            },
            validate(){
                let flag = true;
                let msg  = "";
                if (this.addInfo.title == ''){
                    flag = false;
                    msg = "不能为空 "
                    return {code:flag,msg:msg}
                }
                return {code:flag,msg:msg}
            },
            save(){
                if (this.formLoading)  return; // 防止重复提交
                this.formLoading=true;
                let validateData = this.validate();
                if(!validateData.code){
                    this.$message({
                        message: validateData.msg,
                        type: 'warning'
                    });
                    return;
                }
                if(typeof(this.addInfo.id)=== "undefined" || this.addInfo.id == ''){  // 保存
                    axios.post('/devInfo',this.addInfo).then(result => {
                        this.formLoading=false;
                        this.dialogVisible = false;
                        if (result.code !== 200){
                            console.log(result);
                        }
                        this.clearObj(this.addInfo); // 清空新增数据
                        this.pageInfo();
                    }).catch(err => {
                        this.formLoading=false;
                        console.log(err);
                    });
                }else{  // 编辑
                    // 当前系列 是开启的
                    axios.put('/devInfo',this.addInfo).then(result => {
                        this.formLoading=false;
                        this.dialogVisible = false;
                        if (result.code !== 200){
                            console.log(result);
                        }
                        this.pageInfo();

                        this.clearObj(this.addInfo); // 清空新增数据
                        this.addInfo.id = undefined;
                        this.dialogTitle="新增设备";
                    }).catch(err => {
                        this.formLoading=false;
                        console.log(err);
                    });
                }
            },
            remove(id){
                axios.delete('/devInfo',{data: {id:id}}).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.pageInfo();
                })
            },
            confirmRemove(id){
                this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.remove(id);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleClose(done) {
                this.clearObj(this.addInfo); // 清空新增数据
                done();
            },
            showInfo(obj){
                this.addInfo =JSON.parse(JSON.stringify(obj));
                this.infoDialogVisible = true;
            },
            handleRowDblClick(row, column, event) {

                this.addInfo =JSON.parse(JSON.stringify(row));
                this.infoDialogVisible = true;
            },
            edit(obj){
                this.dialogTitle = "设备编辑";
                this.addInfo =JSON.parse(JSON.stringify(obj));
                this.dialogVisible = true;
            },
            pageInfo(){
                if (this.searchDateArr !=  null && this.searchDateArr != ''){
                    this.searchInfo.searchDate = this.searchDateArr.join('_');
                }

                if (this.loading)  return; // 防止重复提交
                this.loading=true;
                axios.get('/devInfo/history',{
                    params: this.searchInfo
                }).then(result => {
                    this.loading=false;
                    if (result.code !== 200){
                        console.log(result);
                    }
                    let page = result.data;
                    this.total = page.total;
                    this.tableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.loading=false;
                });
            },
        },filters: {
            showState(val){
                if (val == 1){
                    return "已处理";
                }
                return "未处理"
            },
            consumerState(val){
                if (val){
                    return "禁用";
                }
                return "开启"
            }
        }
    }
</script>
<style lang="less" scoped>
    .addInfoStyle div{
        line-height: 4;
        .el-input{
            margin-right: 15px;
            width: 200px;
        }
    }
</style>

